export type ConsoleScope = "PLATFORM" | "TENANT"

export const CONSOLE_SCOPE_PLATFORM = "PLATFORM" as const
export const CONSOLE_SCOPE_TENANT = "TENANT" as const

export const SELECT_CONSOLE_SCOPE_PATH = "/select-console-scope"
